// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__e+E4a","modal-wrapper":"Modal_modal-wrapper__gj0Ye"};